export const WEBSHOP_CAMA_ID = 'PRO_2152128';
export const WEBSHOP_ONLINE_PAYLIMIT = 500;
export const MY_DATA = 'mydata';
